import { recordViewedHome } from 'javascripts/shared/viewed_homes'

// Home detail page: remember this home in the browser's browsing history (see javascripts/shared/viewed_homes.js).
document.addEventListener('DOMContentLoaded', () => {
  const main = document.querySelector('main.homedetail[data-viewed-home-id]')
  if (main) recordViewedHome(main.dataset.viewedHomeId)
})
